import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import AmericoOfferCard from "../../Common/Cards/AmericoOfferCard";
import AutoCarousel from '../../../Helpers/Widgets/AutoCarousel/AutoCarousel';
import { RotatingSteps } from '../../AmericoLoanProtection/Helpers/Constant';
import { Button } from '@mui/material';
import ErrorHandler from '../../../Helpers/Errors/ErrorHandler';
import NoResultsFoundError from '../../../Helpers/Errors/CustomErrors/NoResultsFoundError';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';
import { getHealthClass } from '../Helpers/GetHealthClass';
import Step9Icon from '../icons/step_9.svg?react';
import CheckmarkIcon from '../../../../icons/checkmark.svg?react';
import IconHolder from "../../../Helpers/IconHolder";

export default function Offer(props) {

  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
  const [loading, setLoading] = useState(true);
  const [showSlider, setShowSlider] = useState(false);
  const [monthlyRate, setMonthlyRate] = useState("0");
  const [logoUrl, setLogoUrl] = useState("");
  const [sliderMaxAmount] = useState(props.quoter.coverageAmount);

  let debounce = null;
  useEffect(() => {
    if (props.quoter.coverageAmount == null || props.quoter.healthClass == null || props.quoter.term == null) {
      return;
    }
    setLoading(true);
    let isSubscribed = true;
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => runQuote(() => isSubscribed), 1000);
    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    };
  }, [props.quoter.coverageAmount]);

  const onSetAmount = () => {
    setShowSlider(false);
  };

  function runQuote() {
    setLoading(true);
    let rateA;
    fetch(`${covrServicesUrl}/api/Americo?faceAmount=${props.quoter.coverageAmount}&term=${props.quoter.term}&state=${props.basicInfo.state}&birthdate=${props.basicInfo.birthdate}&healthClass=${getHealthClass(props.quoter.healthClass)}&gender=${props.basicInfo.gender}&tobacco=${props.basicInfo.tobacco}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(data => {
        if (!data) {
          throw new NoResultsFoundError();
        }
        rateA = data.monthlyRate;
        setMonthlyRate(rateA);

        props.handleApprovedPremiumUpdate(props.quoter.premium, rateA);

        setLogoUrl(data.logoUrl);
        setLoading(false);
      }).catch((error) => {
        ErrorHandler(error, rateA);
        setLoading(false);
      });
  }

  const handleAmountChange = (value) => {
    props.onCoverageChanged(value);
    props.onFieldChange('coverageAmount', value);
  };

  const rotatingData = RotatingSteps.map((d, index) => <div className="carousel-text" key={index}>{d.text}</div>);

  const offerData = () => {
    let title = '';
    let subTitle = '';
    let otherSubTitle = '';
    let icon;

    switch (props.status) { 
      case props.statuses.APPROVED:
      case props.statuses.APPROVEDMODIFIED:
        title = 'Congratulations!';
        subTitle = 'You have qualified for instant coverage. Secure your policy today.';
        otherSubTitle = '';
        icon = Step9Icon;
        break;
      case props.statuses.TOOLONG:
      case props.statuses.LONGWAIT:
        title = 'Loading Your Offer';
        subTitle = 'This is taking slightly longer than we expected.';
        otherSubTitle = 'You can close this page or wait for your offer. We will send you an email when your offer is received from the carrier.';
        icon = CheckmarkIcon;
        break;
      default:
        title = 'Loading Your Offer';
        subTitle = 'This usually takes between 3-5 minutes.';
        otherSubTitle = '';
        icon = CheckmarkIcon;
        break;
    }
    return { title: title, subTitle: subTitle, otherSubTitle: otherSubTitle, icon: icon };
  };

  return (
      <Row className="d-flex justify-content-center">
        <Col className='pt-5'>
          <Row className="justify-content-center">
            <IconHolder icon={offerData().icon} viewBox="0 0 25 25" color='primary' />
          </Row>
        <Row className="justify-content-center">
          <Col md={7}>
            <h4 className="offer-headerTitle mb-1">{offerData().title}</h4>
            <h5 className={`offer-subTitle ${offerData().otherSubTitle ? 'mb-2' : 'm-0'}`}>{offerData().subTitle}</h5>
            <h6 className="offerHeaderSubtitle m-0">{offerData().otherSubTitle}</h6>
          </Col>
        </Row>
          <Row className="quoter  pt-4">
            <div className="quoter w-100">
              <div className="budget-based-quoter">
                <Row className="justify-content-center">
                  <AmericoOfferCard
                    logoUrl={logoUrl}
                    amount={props.quoter.coverageAmount}
                    productTitle="LoanMatch Protector"
                    productName="Americo"
                    status={props.status}
                    startAmount={25000}
                    statuses={props.statuses}
                    term={props.quoter.term}
                    productDesc="This unique product's coverage amount decreases monthly and is designed to match a decreasing financial need."
                    monthlyRate={monthlyRate}
                    loading={loading}
                    onNextApply={props.onNext}
                    showSlider={showSlider}
                    onSetAmount={onSetAmount}
                    handleAmountChange={handleAmountChange}
                    sliderMaxAmount={sliderMaxAmount}
                  />
                </Row>

                {(props.status === props.statuses.APPROVED || props.status === props.statuses.APPROVEDMODIFIED) && !showSlider &&
                  <Row className="justify-content-center">
                    <Button type="button" className="btn btn-link" color='primary' onClick={() => { setShowSlider(!showSlider); }}>OTHER PRICE OPTIONS</Button>
                  </Row>
                }
              </div>
            </div>
          </Row>
        </Col>
        {props.status === props.statuses.WAITING &&
        <Row className="carousel-wrapper justify-content-center">
          <Col md={11}>
            <AutoCarousel data={rotatingData} rotatingSteps={RotatingSteps} isHasIndicator={true}/>
          </Col>
      </Row>
        }
    </Row>
  );
}

Offer.propTypes = {
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  quoter: PropTypes.object,
  basicInfo: PropTypes.object,
  status: PropTypes.string,
  onCoverageChanged: PropTypes.func,
  statuses: PropTypes.object,
};
